import { render, staticRenderFns } from "./ExecutiveDashboardPage.vue?vue&type=template&id=b105669e"
import script from "./ExecutiveDashboardPage.vue?vue&type=script&lang=ts"
export * from "./ExecutiveDashboardPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b105669e')) {
      api.createRecord('b105669e', component.options)
    } else {
      api.reload('b105669e', component.options)
    }
    module.hot.accept("./ExecutiveDashboardPage.vue?vue&type=template&id=b105669e", function () {
      api.rerender('b105669e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/ExecutiveDashboardPage.vue"
export default component.exports